import configStore from './configStore';
import state from './initialState';

export const initialState = state;
export const configMyStore = configStore;
